<template>
  <v-flex>
    <v-dialog
      v-if="$vuetify.breakpoint.xsOnly"
      fullscreen
      v-model="isDialog"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn dark icon @click="showLogsDetails(detailedDistributor)">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalles</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pa-0">
          <distributor-details-log-report
            :detailedDistributor="detailedDistributor"
          ></distributor-details-log-report>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import {isEmpty} from 'lodash'

import DistributorDetailsLogReport from '../../components/logs/distributor-details-log-report'

export default {
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    areDetailsShown () {
      return !isEmpty(this.detailedDistributor)
    },
    isDialog () {
      return this.areDetailsShown
    }
  },
  components: {
    DistributorDetailsLogReport
  },
  props: {
    detailedDistributor: {
      type: Object,
      default () {
        return {}
      }
    },
    showLogsDetails: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/show-distributor-details-dialog.vue